//@flow
import React from "react"
import { connect } from "react-redux"
import { replace, push } from "react-router-redux"
import { compose } from "react-apollo"
import { Helmet } from "react-helmet"
import {
  EntityHeading,
  EntityDetail,
  Entity,
  EntityAction,
  EntityPrimaryLink
} from "../UI/EntityList"
import { parseQueryString } from "../RoutingHelpers"
import { SearchTableView } from "../SearchTableView"
import queries from "./queries"
import type { UserListViewProps } from "./types"
import { confirmDeletePath } from "./helpers"

type State = { mutationLoading: boolean }

class UserListView extends React.Component<UserListViewProps, State> {
  constructor(props) {
    super(props)
    this.state = { mutationLoading: false }
  }

  render() {
    const {
      users: { users, loading },
      match,
      replace,
      searchName,
      history: { push }
    } = this.props
    const count = users ? users.length : 0
    return (
      <SearchTableView
        url={match.url}
        routerAction={replace}
        entityName="Users"
        searchName={searchName}
        handleNewClick={() => push(`${match.url}/new`)}
        loading={loading || this.state.mutationLoading}
      >
        <Helmet>
          <title>
            {`${count} User${count === 1 ? "" : "s"}${searchName !== ""
              ? ` Matching '${searchName}'`
              : ""}`}
          </title>
        </Helmet>
        <EntityHeading>
          <EntityDetail grow={2}>Name</EntityDetail>
          <EntityDetail grow={1}>Email</EntityDetail>
          <EntityDetail grow={1}>Is Admin?</EntityDetail>
          <EntityDetail grow={1} shrink={0} />
        </EntityHeading>
        {users &&
          users.map(user => (
            <Entity key={user.id}>
              <EntityDetail grow={2}>
                <EntityPrimaryLink to={`${match.url}/${user.id}`}>
                  {user.name}
                </EntityPrimaryLink>
              </EntityDetail>
              <EntityDetail grow={1}>{user.email}</EntityDetail>
              <EntityDetail grow={1}>
                {user.admin ? "Yes" : "Needs Approval"}
              </EntityDetail>
              <EntityDetail grow={1} shrink={0} row end>
                <EntityAction
                  href="#"
                  onClick={() => push(`${match.url}/${user.id}`)}
                  icon="✏️"
                />
                <EntityAction
                  href="#"
                  onClick={() => push(confirmDeletePath(user.id))}
                  icon="❌"
                />
              </EntityDetail>
            </Entity>
          ))}
      </SearchTableView>
    )
  }
}

const UsersWithData = compose(queries.withUsers)(UserListView)

export default connect(
  state => ({
    searchName: parseQueryString(state, "name")
  }),
  {
    replace,
    push
  }
)(UsersWithData)



// WEBPACK FOOTER //
// ./src/Users/UserListView.js